<template>
  <div
    class="c-divider"
    :style="wrapperStyle"
  >
    <div :style="innerStyle" />
  </div>
</template>

<script>
export default {
  name: 'CDivider',
  props: {
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    wrapperStyle() {
      if (this.size === 'none') {
        return 'display: flex; align-items: center; justify-content: center; pointer-events: none; width: 100%; height: 2px; flex: 0 0 auto;';
      }
      if (this.size === 'small') {
        return 'display: flex; align-items: center; justify-content: center; pointer-events: none; width: 100%; height: 15px; flex: 0 0 auto;';
      }
      return 'display: flex; align-items: center; justify-content: center; pointer-events: none; width: 100%; height: 60px; flex: 0 0 auto;';
    },
    innerStyle() {
      return 'width: 100%; height: 1px; visibility: visible; border-bottom: 1px solid rgba(55, 53, 47, 0.16);';
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
